export default __webpack_public_path__ + "static/media/04.26.24 Minutes of the Organizational Meeting of the BOD.72b52fe7.pdf";